import Vue from 'vue'
import InfoSection from './InfoSection/InfoSection.vue'
import PortfolioSection from './PortfolioSection/PortfolioSection.vue'
import PortfolioProject from '@/models-ts/user/PortfolioProject'
import MyFreelancerProfile from '@/models-ts/user/profiles/freelancer/MyFreelancerProfile'

export default Vue.extend<any, any, any, any>({
  components: {
    InfoSection,
    PortfolioSection,
  },
  props: {
    profile: MyFreelancerProfile,
  },
  methods: {
    onFreelanceInfoUpdate(profile: MyFreelancerProfile) {
      this.$emit('update', profile)
    },
    onPortfolioUpdate(portfolio: Array<PortfolioProject>) {
      this.$emit('update', { ...this.profile, portfolio })
    },
  },
})
